// extracted by mini-css-extract-plugin
export default {"featherIcon":"FeatherIcon_featherIcon__-3UNX"};